module.exports = __webpack_public_path__ + "img/circulo_banner_edited.96954d25.jpg";